module.exports = __webpack_public_path__ + "img/instagram.304fb315.svg";